import React from "react";
import { CATEGORY_COLORS } from "../../hooks/useGitHubSkills";

const SkillLegend = () => (
  <div className="skill-legend">
    {Object.entries(CATEGORY_COLORS).map(([cat, color]) => (
      <div key={cat} className="skill-legend-item">
        <span className="skill-legend-dot" style={{ background: color }} />
        <span className="skill-legend-label">{cat}</span>
      </div>
    ))}
  </div>
);

export default SkillLegend;
